(function () {
  const modal = document.getElementById('size-chart-modal');
  if (!modal) return;

  const overlay = modal.querySelector('.size-chart-modal__overlay');
  const closeBtn = modal.querySelector('.size-chart-modal__close');
  const head = document.getElementById('size-chart-head');
  const body = document.getElementById('size-chart-body');
  const unitsEl = modal.querySelector('.size-chart-modal__units');
  const titleEl = modal.querySelector('.size-chart-modal__title');

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatValue(v) {
    if (v == null || v === '') return '—';
    const n = Number(v);
    if (!isFinite(n)) return String(v);
    // round to 1 decimal, strip trailing .0 (e.g. 50.55 → 50.6, 50 → 50, 50.5 → 50.5)
    return (Math.round(n * 10) / 10).toString();
  }

  function openModal(data) {
    const sizes = Array.isArray(data.sizes) ? data.sizes : [];
    const measurements = Array.isArray(data.measurements) ? data.measurements : [];
    const units = data.units || 'inches';

    if (titleEl) titleEl.textContent = 'Size Chart';
    if (unitsEl) unitsEl.textContent = 'All measurements in ' + units;

    head.innerHTML = '<tr><th></th>' +
      sizes.map(function (s) { return '<th>' + escapeHtml(s) + '</th>'; }).join('') +
      '</tr>';

    body.innerHTML = measurements.map(function (m) {
      const cells = sizes.map(function (s) {
        const v = m.values ? m.values[s] : null;
        return '<td>' + escapeHtml(formatValue(v)) + '</td>';
      }).join('');
      return '<tr><td>' + escapeHtml(m.name || '') + '</td>' + cells + '</tr>';
    }).join('');

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.size-chart-trigger');
    if (!trigger) return;
    try {
      const raw = trigger.getAttribute('data-size-chart');
      const data = JSON.parse(raw);
      openModal(data);
    } catch (err) {
      console.error('Size chart parse error:', err);
    }
  });

  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
